module.exports = __webpack_public_path__ + "img/7.b0504a75.jpg";